import useSWR from "swr";
import axiosInstance from "../axios/axios-instance";
import { pathAPI } from "../utils/pathApi";

interface CountryData {
  id: number;
  name: string;
  code: string;
  country_code: string;
  flag: string;
  currency: string;
  currency_symbol: string;
  phone_code: string;
  language_id: number;
  active: boolean;
}

interface CityData {
  id: number;
  name: string;
  active: boolean;
}

async function getCountries(): Promise<CountryData[]> {
  return await axiosInstance
    .get(`${pathAPI.countries}`)
    .then((r) => r.data?.data);
}

async function getCities(slug: string): Promise<CityData[]> {
  if (!slug) {
    return [];
  }
  return await axiosInstance
    .get(`${pathAPI.cities.replace(":slug", slug)}`)
    .then((r) => r.data?.data);
}

async function getDistricts(slug: string, id: string): Promise<CityData[]> {
  if (!slug || !id) {
    return [];
  }
  return await axiosInstance
    .get(`${pathAPI.district.replace(":slug", slug).replace(":id", id)}`)
    .then((r) => r.data?.data);
}

export const useCountries = () => {
  const { data, error, isLoading, mutate } = useSWR<CountryData[]>(
    pathAPI.countries,
    () => getCountries()
  );

  return [{ data: data || [], error, isLoading }, { mutate }] as const;
};

export const useCitys = ({ slug }: { slug?: string }) => {
  const { data, error, isLoading, mutate } = useSWR<CityData[]>(
    `${slug ? pathAPI.cities.replace(":slug", slug) : ""}`,
    slug && slug !== "" ? () => getCities(slug) : null
  );

  return [{ data: data || [], error, isLoading }, { mutate }] as const;
};

export const useDistrict = ({ slug, id }: { slug: string; id: string }) => {
  const { data, error, isLoading, mutate } = useSWR<CityData[]>(
    `${pathAPI.district.replace(":slug", slug).replace(":id", id)}`,
    () => getDistricts(slug, id)
  );

  return [{ data: data || [], error, isLoading }, { mutate }] as const;
}; 
